export default "__VITE_ASSET__CJ1iDfN8__"